import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { CurrentAddressComponent } from "../../wizard/wizard-steps/current-address/current-address.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class CurrentAddressStep extends WizardStepBase {
  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = CurrentAddressComponent;
  }
}
